import { createEnv } from "@poscon/shared-types";

const envKeys = ["VITE_ERAM_SERVER_URL", "VITE_NEXRAD_SERVER_URL", "VITE_SENTRY_URL_STARS"] as const;
const partialEnvKeys = ["VITE_AUTO_SIGNIN_POSITION", "VITE_AUTO_SIGNIN_ARTCC_ID"] as const;

export const env = createEnv(import.meta.env, envKeys, partialEnvKeys);
